module.exports = __webpack_public_path__ + "static/media/led_pro.602a9683.png";